import _ from 'lodash';
import React from 'react'
import useStyles from './content-group-style'
import Carousel from '../../carousel'
import { combineClassNames } from '../../../helpers'

function TemplateBanner4Col(props) {
  const {
    contentGroup,
    onClickTrackEvent,
    template,
    configOptions,
  } = props
  const { contentGroupLines } = contentGroup
  const {
    row, col, imageBoxFourImage, carouselBanner,
  } = useStyles()
  const onClick = (label) => {
    onClickTrackEvent(template, label)
  }
  return (
    <div className={combineClassNames([row, _.get(configOptions, 'htmlClass')])}>
      <div className={col}>
        <Carousel
          autoplay={false}
          images={contentGroupLines}
          slidesToShowDesktop={4}
          slidesToShowMobile={1}
          imageBoxClassName={imageBoxFourImage}
          className={carouselBanner}
          marginCarousel="0"
          marginCarouselDesktop="0"
          postionDots={-15}
          darkDots
          onClick={onClick}
        />
      </div>
    </div>
  )
}

export default TemplateBanner4Col
